<template>
  <section v-loading="listLoading" class="page-container">
    <!--工具条-->
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <!--
        <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"></el-input>
        </el-form-item>
        -->
        <el-form-item>
          <el-button type="primary" @click="list">刷新</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="showImport">导入</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--列表-->
    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        height="100%"
        :data="results"
        highlight-current-row
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="word" label="词组"></el-table-column>
        <el-table-column prop="sortNo" label="排序"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="{ row }">{{
            row.status === 0
              ? "待发布"
              : row.status === 10
              ? "上架"
              : row.status === 20
              ? "下线"
              : row.status === 30
              ? "删除"
              : row.status
          }}</template>
        </el-table-column>
        <el-table-column prop="createUserId" label="创建人编号"></el-table-column>
        <el-table-column prop="createUserName" label="创建人名称"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="updateUserId" label="更新人编号"></el-table-column>
        <el-table-column prop="updateUserName" label="更新人名称"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-dropdown type="primary" @command="handleCommand">
              <el-button type="primary" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ type: 'edit', index: scope.$index, data: scope.row }"
                  >编辑</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'delete', index: scope.$index, data: scope.row }"
                  >删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="词组">
          <el-input v-model="addForm.word"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="addForm.sortNo"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <status-select v-model="addForm.status" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="词组">
          <el-input v-model="editForm.word"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="editForm.sortNo"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <status-select v-model="editForm.status" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog title="导入" :visible.sync="importFormVisible" :close-on-click-modal="false">
      <div>
        <h2>导入模版：</h2>
        <p>1. 第一行为表头</p>
        <p>2. 第一列为词组</p>
        <p>3. 第二列为排序</p>
      </div>
      <el-upload
        ref="import"
        drag
        :action="importActionUrl"
        :auto-upload="false"
        :headers="uploadHeaders"
        :on-error="submitImportError"
        with-credentials
        name="file"
        accept="application/vnd.ms-excel"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传xls文件</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="importFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="importLoading" @click.native="submitImport"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import mainHeight from "@/utils/mainHeight";
import StatusSelect from "@/components/StatusSelect";
import { getToken } from "@/utils/auth";
import { getLocale } from "@/utils/locale";

export default {
  name: "SearchAutocomplete",
  components: { MyPagination, StatusSelect },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: true,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,

      importFormVisible: false,
      importActionUrl: process.env.VUE_APP_MALL_API + "/api/admin/search-autocomplete/importExcel",
      importLoading: false,
    };
  },
  computed: {
    uploadHeaders() {
      const userToken = getToken();
      const locale = getLocale();
      return {
        "X-User-Token": userToken || "",
        "X-User-Locale": locale || "",
      };
    },
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        this.results = [];
        const data = await this.axios.form("mall:/api/admin/search-autocomplete/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleCommand(cmd) {
      switch (cmd.type) {
        case "edit":
          this.handleEdit(cmd.index, cmd.data);
          break;
        case "delete":
          this.deleteSubmit(cmd.index, cmd.data);
          break;
        default:
          break;
      }
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        await this.axios.post("mall:/api/admin/search-autocomplete/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/search-autocomplete/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        await this.axios.post("mall:/api/admin/search-autocomplete/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },
    async deleteSubmit(index, row) {
      const me = this;
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .delete("mall:/api/admin/search-autocomplete/" + row.id)
            .then((data) => {
              me.$message({ message: "删除成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    showImport() {
      this.importFormVisible = true;
    },
    async submitImport() {
      if (this.importLoading) {
        return;
      }
      this.importLoading = true;
      try {
        await this.$refs.import.submit();
        // this.$refs.import.clearFiles();
        // this.importFormVisible = false;
        this.$notify.success("提交成功，系统正在导入中，请手动刷新页面查看导入结果。");
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.importLoading = false;
      }
    },
    submitImportError(err, file, fileList) {
      this.$notify.error({ title: "错误", message: err.message || err });
    },
  },
};
</script>

<style lang="scss" scoped></style>
